/**
 * @generated SignedSource<<50e3b3b1eb6f852415abc139f9f8932d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCustomerOrg_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly contributors?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
    readonly customerOrgLastActivity?: {
      readonly event: string | null;
      readonly lastActivityAt: string | null;
    } | null;
    readonly displayName?: string | null;
    readonly owners?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
    } | null> | null;
    readonly parent?: {
      readonly displayName?: string | null;
      readonly id?: string;
    } | null;
  } | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCustomerOrg_AtlassianSearchPage";
};
export type searchGraphCustomerOrg_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCustomerOrg_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCustomerOrg_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphCustomerOrg_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v4/*: any*/),
            {
              "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "contributors",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ThirdPartyUser",
                      "kind": "LinkedField",
                      "name": "thirdPartyUser",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v5/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "owners",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ThirdPartyUser",
                      "kind": "LinkedField",
                      "name": "thirdPartyUser",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    (v4/*: any*/)
                  ],
                  "type": "ExternalCustomerOrg"
                }
              ]
            },
            {
              "concreteType": "ExternalCustomerOrgLastActivity",
              "kind": "LinkedField",
              "name": "customerOrgLastActivity",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "lastActivityAt"
                },
                {
                  "kind": "ScalarField",
                  "name": "event"
                }
              ]
            }
          ],
          "type": "ExternalCustomerOrg"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "f865c9e7b61b842c45c871a53ff1a606";

export default node;
